import { LookupBase, NeoModel } from '@singularsystems/neo-core';

@NeoModel
export default class BranchDetailLookup extends LookupBase {

    public branchId: number = 0;

    public businessUnitId: number = 0;

    public branchNo: string = "";

    public profitCentreName: string = "";

    public groupName: string = "";

    public profitCentre: string = "";

    // Client only properties / methods
}